import { render } from "./writingAssessmentModal.vue?vue&type=template&id=d84e0444&scoped=true"
import script from "./writingAssessmentModal.vue?vue&type=script&lang=js"
export * from "./writingAssessmentModal.vue?vue&type=script&lang=js"

import "./writingAssessmentModal.vue?vue&type=style&index=0&id=d84e0444&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84e0444"]])

export default __exports__